// Import LitElement base class and html helper function
import {LitElement, html, css, svg} from 'lit';
import {classMap} from 'lit/directives/class-map.js';

export class StreamBoxHr extends LitElement {
    /**
     * Define properties. Properties defined here will be automatically
     * observed.
     */
    static get properties() {
        return {
            user_name: {type: String},
            max_hr: {type: Number},
            hr: {type: Number},
            percentage_hr: {type: Number},
            calories: {type: Number},
            box_color: {type: Object},
            zones_range: {type: Array},
            hide_zone_index: {type: Boolean}
        };
    }

    static get styles() {
        return css`
            .box-0 {
                background: var(--box-0-default);
                background: var(--box-0-grad);
            }
            .box-1 {
                background: var(--box-1-default);
                background: var(--box-1-grad);
            }
            .box-2 {
                background: var(--box-2-default);
                background: var(--box-2-grad);
            }
            .box-3 {
                background: var(--box-3-default);
                background: var(--box-3-grad);
            }
            .box-4 {
                background: var(--box-4-default);
                background: var(--box-4-grad);
            }
            .stream-box {
                width: var(--stream-box-width);
                height: var(--stream-box-height);
                border-radius: 10px;
                padding: 10px;
                display: flex;
                display: -webkit-flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: space-between;
                align-items: stretch;
            }
            .stream-box-upper {
                flex: 1 1 auto;
                font-size: 1.6em;
                font-weight: 600;
                text-align: center;
                color: #222222;
                position: relative;
            }
            .stream-box-upper .stream-box-upper-float-left {
                position: absolute;
                top: 1em;
                left: 0;
            }
            .stream-box-main {
                flex: 2 1 auto;
                font-size: 2.5em;
                font-weight: 600;
                color: #222222;
                text-align: center;
                display: flex;
                display: -webkit-flex;
                flex-direction: column;
                justify-content: center;
            }
            .stream-box-main .unit {
                font-size: 0.5em;
            }
            .stream-box-main .value {
                font-size: var(--stream-box-main-size);
                margin-bottom: var(--stream-box-main-margin);
                margin-top: var(--stream-box-main-margin);
            }
            .stream-box-footer {
                flex: 1 1 auto;
                -webkit-flex: 1 1 auto;
                font-size: 1.6em;
                font-weight: 600;
            }
            .stream-box-footer .align-left {
                text-align: left;
                float: left;
            }
            .stream-box-footer .align-right {
                text-align: right;
                float: right;
            }
            .icon {
                display: inline-block;
                stroke-width: 0;
                stroke: currentColor;
                fill: currentColor;
                width: 0.9em;
            }
        `;
    }

    // Custom setter for hr
    set hr(val) {
        let oldVal = this._hr;
        this._hr = val;
        let oldPercentage = this.percentage_hr;
        if (this.max_hr > 0) {
            this.percentage_hr = Math.round((val * 100) / this.max_hr);
        }
        let z_index = 0;
        for(var i=1; i < this.zones_range.length; i++){
            if (this.percentage_hr <= this.zones_range[i]){
                break;
            }
            z_index = z_index + 1;
        }
        let oldBoxColor= this.box_color;
        let zone_key = 'box-' + z_index;
        this.box_color = {'stream-box':true, [zone_key]: true};
        let oldZoneIndex = this.zone_index;
        this.zone_index = z_index + 1;
        this.requestUpdate('hr', oldVal);
        this.requestUpdate('percentage_hr', oldPercentage);
        this.requestUpdate('box_color', oldBoxColor);
        this.requestUpdate('zone_index', oldZoneIndex);
    }

    get hr() { return this._hr; }

    constructor() {
        super();
        this.max_hr = 0;
        this.box_color = {'stream-box': true, 'box-0': true};
        this.zones_range = [0,60,70,80,90];
        this.user_name = 'Loading';
        this.percentage_hr = 0;
        this.hr = 0;
        this.calories = 0;
        this.zone_index = null;
        this.hide_zone_index = false;
    }

    render() {
        return html`
            <div class="${classMap(this.box_color)}">
                <div class="stream-box-upper">${this.user_name}
                    ${this.zone_index && !this.hide_zone_index?
                        html`<span class="stream-box-upper-float-left">Z${this.zone_index}</span>`:
                        html``}
                </div>
                <div class="stream-box-main">
                    <div class="value">${this.percentage_hr}<span class="unit">%</span></div>
                </div>
                <div class="stream-box-footer">
                    <div class="align-left">${this.svgHrIcon} ${this.hr}</div>
                    <div class="align-right">${this.calories} ${this.svgCaloriesIcon}</div>
                </div>
            </div>
        `;
    }

    get svgHrIcon() {
        return svg`<svg viewBox="0 0 100 100" class="icon"><use xlink:href="/img/stream-icons.svg#icon-heart" href="/img/stream-icons.svg#icon-heart"/></svg>`;
    }

    get svgCaloriesIcon() {
        return svg`<svg viewBox="0 0 100 100" class="icon"><use xlink:href="/img/stream-icons.svg#icon-calories" href="/img/stream-icons.svg#icon-calories"/></svg>`;
    }
}
